import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component"; // Import DataTable
import { Edit, Trash2 } from "react-feather";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Link } from "react-router-dom";
import { baseurl } from "../../Baseurl";
import axios from "axios";

const AdminAddAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState({
    adminName: "",
    email: "",
    password: "",
    role: "",
    modules: [],
  });

  // Available modules (checkbox options)
const availableModules = [
  { 
    id: 1, 
    name: "Dashboard", 
    routes: ["/admin/dashboard", "/admin/seller-list-cost", "/admin/review", "/admin/direct-purchase", "/admin/all-enquiry", "/admin/contact", "/admin/seller-quote"] 
  },
  { 
    id: 2, 
    name: "Manage Website", 
    routes: ["/admin/item-category", "/admin/all-category", "/admin/all-trash-category", "/admin/all-service-category", "/admin/all-service-request", "/admin/full-banner", "/admin/all-coupon", "/admin/approve-listing", "/admin/all-approved-listing", "/admin/all-rejected-listing", "/admin/download"] 
  },
  { 
    id: 3, 
    name: "Report / Product listing", 
    routes: ["/admin/seller-report", "/admin/all-sellers", "/admin/all-customer", "/admin/all-listings", "/admin/education-category", "/admin/add-education", "/admin/all-education"] 
  },
  { 
    id: 4, 
    name: "Orders", 
    routes: ["/admin/all-orders", "/admin/ship-to"] 
  },
  { 
    id: 5, 
    name: "Blog Management", 
    routes: ["/admin/add-blog-category", "/admin/add-blog", "/admin/blog-list"] 
  }
];
  
  const handleModuleChange = (moduleId) => {
    setSelectedAdmin((prev) => {
      const isSelected = prev.modules.some((mod) => mod.id === moduleId);
      
      return {
        ...prev,
        modules: isSelected
          ? prev.modules.filter((mod) => mod.id !== moduleId) // Remove if already selected
          : [...prev.modules, availableModules.find((mod) => mod.id === moduleId)], // Add if not selected
      };
    });
  };

  // Handle Modal Open/Close
  const handleShowModal = (admin = null) => {
    setSelectedAdmin(
      admin || { adminName: "", email: "", password: "", role: "", modules: [] }
    );
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  // Handle Form Submission (Add/Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    console.log("Sending Admin Data:", selectedAdmin); // Log the data before sending
  
    try {
      if (selectedAdmin.id) {
        // Update Admin
        const response = await axios.put(`${baseurl}updateAdmin`, selectedAdmin);
  
        console.log("Update Response:", response); // Log the API response
  
        if (response.status === 200) {
          setAdmins((prev) =>
            prev.map((admin) =>
              admin.id === selectedAdmin.id ? selectedAdmin : admin
            )
          );
          Swal.fire("Updated!", "Admin details updated successfully.", "success");
        }
      } else {
        // Add New Admin
        const response = await axios.post(`${baseurl}addAdminuser`, selectedAdmin);
  
        console.log("Add Response:", response); // Log the API response
  
        if (response.status === 201) {
          setAdmins((prev) => [...prev, { ...selectedAdmin, id: response.data.id }]);
          Swal.fire("Added!", "New admin added successfully.", "success");
        }
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error saving admin:", error.response ? error.response.data : error); // Log error details
      Swal.fire("Error!", "An error occurred while saving the admin.", "error");
    }
  };
  
  

 const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This admin will be deleted permanently!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // Call your backend API
        const response = await axios.delete(`${baseurl}deleteAdmin/${id}`);
        
        if (response.status === 200) {
          // Update the state locally to remove the deleted row from the UI
          setAdminData((prev) => prev.filter((admin) => admin.id !== id));
          Swal.fire("Deleted!", "Admin has been removed.", "success");
        }
      } catch (error) {
        console.error("Error deleting admin:", error);
        Swal.fire("Error!", "Failed to delete admin from the database.", "error");
      }
    }
  });
};

  // Handle Checkbox Selection
 

  const [adminData, setAdminData] = useState([]);

  // Fetch all admin data
  const FetchAllAdminData = async () => {
    try {
      const response = await axios.get(`${baseurl}FetchAllAdminData`);
      const admins = response.data.admins.map((admin) => ({
        ...admin,
        modules: admin.modules.map((module) => JSON.parse(module).name), // Extract module names
      }));
      setAdminData(admins);
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
  };

  useEffect(() => {
    FetchAllAdminData();
  }, []);

  // Define columns for DataTable
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Admin Name",
      selector: (row) => row.first_name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.admin_email,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row) => row.role,
      sortable: true,
    },
    {
      name: "Modules",
      selector: (row) => row.modules.join(", "), // Display modules as a comma-separated string
      sortable: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <Link to={`/edit-admin/${row.id}`} className="btn btnedit me-2" >
            <Edit size={16} />
          </Link>
          <button className="btn btndelete" onClick={() => handleDelete(row.id)}>
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content Area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">All Admins</h4>
            <button className="addbtn" onClick={() => handleShowModal()}>
              Add Admin
            </button>
          </div>

          {/* React DataTable */}
          <div className="table-responsive">
            <DataTable columns={columns} data={adminData} pagination highlightOnHover responsive />
          </div>

          {/* Bootstrap Modal */}
          {showModal && (
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
              <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">{selectedAdmin.id ? "Edit Admin" : "Add Admin"}</h5>
                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3 text-start">
                        <label htmlFor="adminName" className="form-label">Admin Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="adminName"
                          placeholder="Enter Admin Name"
                          value={selectedAdmin.adminName}
                          onChange={(e) => setSelectedAdmin({ ...selectedAdmin, adminName: e.target.value })}
                          required
                        />
                      </div>

                      <div className="mb-3 text-start">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter Email"
                          value={selectedAdmin.email}
                          onChange={(e) => setSelectedAdmin({ ...selectedAdmin, email: e.target.value })}
                          required
                        />
                      </div>

                      <div className="mb-3 text-start">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Enter Password"
                          value={selectedAdmin.password}
                          onChange={(e) => setSelectedAdmin({ ...selectedAdmin, password: e.target.value })}
                          required
                        />
                      </div>

                      <div className="mb-3 text-start">
                        <label className="form-label">Role</label>
                        <select
                          className="form-select"
                          value={selectedAdmin.role}
                          onChange={(e) => setSelectedAdmin({ ...selectedAdmin, role: e.target.value })}
                          required
                        >
                          <option value="">Select Role</option>
                          <option value="super-admin">Super Admin</option>
                          <option value="admin">admin</option> 
                        </select>
                      </div>

                      <div className="mb-3 text-start">
    <label className="form-label">Modules</label>
    {availableModules.map((module) => (
      <div key={module.id} className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          checked={selectedAdmin.modules.some((mod) => mod.id === module.id)}
          onChange={() => handleModuleChange(module.id)}
        />
        <label className="form-check-label">{module.name}</label>
      </div>
    ))}
  </div>

                      <div className="text-end">
                        <button type="submit" className="btn submitbtnn">Save</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default AdminAddAdmin;
